import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/uk';
import 'dayjs/locale/en';
import 'dayjs/locale/en-gb';
import { useDateTime } from "../../context/DateTimeContext";

interface DateFieldRendererProps {
  field: {
    name: string;
    label: string;
  };
  value: string;
  setValue: (value: string) => void;
  error?: string;
  touched?: boolean;
  t: (key: string) => string;
  onBlur?: (e: React.FocusEvent<any>) => void;
  disabled?: boolean;
}

const getLocaleForDayjs = (locale: string): string => {
  const localeMap: Record<string, string> = {
    'en-US': 'en',
    'en-GB': 'en-gb',
    'ru-RU': 'ru',
    'uk-UA': 'uk',
  };
  return localeMap[locale] || 'en';
};

const getDateFormat = (locale: string): string => {
  const formatMap: Record<string, string> = {
    'en-US': 'MM/DD/YYYY',
    'en-GB': 'DD/MM/YYYY',
    'ru-RU': 'DD.MM.YYYY',
    'uk-UA': 'DD.MM.YYYY',
  };
  return formatMap[locale] || 'DD.MM.YYYY';
};

export default function DateFieldRenderer({
  field,
  value,
  setValue,
  error,
  touched,
  t,
  onBlur,
  disabled,
}: DateFieldRendererProps) {
  const { locale } = useDateTime();
  const dayjsLocale = getLocaleForDayjs(locale);
  const dateFormat = getDateFormat(locale);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjsLocale}>
      <DatePicker
        label={t(field.label)}
        value={value ? dayjs(value) : null}
        onChange={(newValue: Dayjs | null) => {
          setValue(newValue ? newValue.format('YYYY-MM-DD') : '');
        }}
        disabled={disabled}
        maxDate={dayjs()}
        format={dateFormat}
        slotProps={{
          textField: {
            fullWidth: true,
            name: field.name,
            onBlur: onBlur,
            error: Boolean(touched && error),
            helperText: touched && error ? t(error!) : '',
          },
        }}
      />
    </LocalizationProvider>
  );
}